import { render, staticRenderFns } from "./DualListOrders.vue?vue&type=template&id=72c779ed&"
import script from "./DualListOrders.vue?vue&type=script&lang=js&"
export * from "./DualListOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports